import { Injectable } from '@angular/core';
import { CellRendererTypes } from '../../shared/widgets/data-grid/enums/cell-renderer.enum';
import { FilterTypes } from '../../shared/widgets/data-grid/enums/filter-types.enum';
import { TableColumn } from '../../shared/widgets/data-grid/interfaces/table-column.interface';

@Injectable()
export class ExecutiveSummaryGridService {
  
  constructor() { }   
    
    areaFormatter(rowData, field) {
        let value;
        let percentage;

        switch (field) {
          case 'thisMonthRegistrations':
            value = Number(rowData[field].toFixed(1)).toLocaleString();
            percentage = rowData.monthRegistrationPercentage;
            break;
          case 'thisMonthRegistrationsCount':
            value = rowData[field].toLocaleString();
            percentage = rowData.monthRegistrationCountPercentage;
            break;
          case 'thisMonthCertifications':
            value = Number(rowData[field].toFixed(1)).toLocaleString();
            percentage = rowData.monthCertificationPercentage;
            break;
          case 'thisMonthCertificationCount':
            value = rowData[field].toLocaleString();
            percentage = rowData.monthCertificationCountPercentage;
            break;
          case 'ytdRegistrations':
            value = Number(rowData[field].toFixed(1)).toLocaleString();
            percentage = rowData.ytdRegistrationPercentage;
            break;
          case 'ytdRegistrationCount':
            value = rowData[field].toLocaleString();
            percentage = rowData.ytdRegistrationCountPercentage;
            break;
          case 'ytdCertification':
            value = Number(rowData[field].toFixed(1)).toLocaleString();
            percentage = rowData.ytdCertificationPercentage;
            break;
          case 'ytdCertificationCount':
            value = rowData[field].toLocaleString();
            percentage = rowData.ytdCertificationCountPercentage;
            break;
        }
      
        if (percentage === undefined || percentage === null) {
            return `<span>${value} </span><span class="text-font12px"> (-)</span >`;
        }
        else if (percentage === 0) {
            return `<span>${value}</span><span class="text-font12px"> (${percentage}%)</span>`;
        }
        else if (percentage > 0) {
            return `<span>${value}</span><span class="text-font12px text-green"> (${percentage}%)</span>`;
        }
        else {          
            return `<span>${value}</span><span class="text-font12px text-red"> (${percentage * -1}%)</span>`;
        }
    };

    formatterBusinessPlan(rowData, field) {
        const value = rowData[field];
        if (value != null && value != '') {
            return `<span>${Number(value.toFixed(1)).toLocaleString()}</span>`
        }
        else {
            return `<span>TBD</span>`
        }
    }

    formatterPerctageToTarget(rowData, field) {
        const value = rowData[field];
        if (value != null && value != '') {
            return `<span>${value}</span>`;
        }
        else {
            return `<span>N/A</span>`;
        }
    }

    //colGroups: TableColumnGroups = {
    //    colGroups: this.getColumnGroups()
    //};

    getColumnGroups(month, year): any {
        var multi = [
          [
            { header: '', colspan: '1' },
            { header: `This Month - ${month} ${year}`, colspan: '4' },
            { header: `FY YTD till ${month} ${year}`, colspan: '6' },
          ],
          [
            { header: '', colspan: '1' },
            { header: 'Registration', colspan: '2' },
            { header: 'Certification', colspan: '2' },
            { header: 'Registrations', colspan: '2' },
            { header: 'Certification', colspan: '4' }
          ]
        ];

        return { colGroups: multi };
    };

    cols: Array<TableColumn> = [
        {
            field: 'country',
            header: 'Country',
            pinned: false, 
            sort: true,          
            sortName: 'country',            
            filter: { type: FilterTypes.text }
        },
        {
            field: 'thisMonthRegistrations',
            header: '1,000 m²',
            sort: true,
            sortName: 'thisMonthRegistrations',
            filter: { type: FilterTypes.text },
            cellRenderer: {
              type: CellRendererTypes.html,
              renderHtml: this.areaFormatter
            }
        },
        {
            field: 'thisMonthRegistrationsCount',
            header: 'Count',
            sort: true,
            sortName: 'thisMonthRegistrationsCount',
            filter: { type: FilterTypes.text },
            cellRenderer: {
              type: CellRendererTypes.html,
              renderHtml: this.areaFormatter
            }
        },
        {
            field: 'thisMonthCertifications',
            header: '1,000 m²',
            sort: true,
            sortName: 'thisMonthCertifications',
            filter: { type: FilterTypes.text },
            cellRenderer: {
              type: CellRendererTypes.html,
              renderHtml: this.areaFormatter
            }
        },       
        {
            field: 'thisMonthCertificationCount',
            header: 'Count',
            sort: true,
            sortName: 'thisMonthCertificationCount',
            filter: { type: FilterTypes.text },
            cellRenderer: {
              type: CellRendererTypes.html,
              renderHtml: this.areaFormatter
            }
        },
        {
            field: 'ytdRegistrations',
            header: '1,000 m²',
            sort: true,
            sortName: 'ytdRegistrations',
            filter: { type: FilterTypes.text },
            cellRenderer: {
              type: CellRendererTypes.html,
              renderHtml: this.areaFormatter
            }
        },
        {
            field: 'ytdRegistrationCount',
            header: 'Count',
            sort: true,
            sortName: 'ytdRegistrationCount',
            filter: { type: FilterTypes.text },
            cellRenderer: {
              type: CellRendererTypes.html,
              renderHtml: this.areaFormatter
            }
        },
        {
            field: 'ytdCertification',
            header: '1,000 m²',
            sort: true,
            sortName: 'ytdCertification',
            filter: { type: FilterTypes.text },
            cellRenderer: {
              type: CellRendererTypes.html,
              renderHtml: this.areaFormatter
            }
        },
        {
            field: 'currentFYBusinessPlanTarget',
            header: 'Target [SECO6]',
            sort: true,
            sortName: 'currentFYBusinessPlanTarget',
            filter: { type: FilterTypes.text },
            cellRenderer: {
              type: CellRendererTypes.html,
              renderHtml: this.formatterBusinessPlan
            }
        },
        {
            field: 'currentFYPerctageToTarget',
            header: '% to Target',
            sort: true,
            sortName: 'currentFYPerctageToTarget',
            filter: { type: FilterTypes.text },
            cellRenderer: {
              type: CellRendererTypes.html,
              renderHtml: this.formatterPerctageToTarget
            }
        },
        {
            field: 'ytdCertificationCount',
            header: 'Count',
            sort: true,
            sortName: 'ytdCertificationCount',
            filter: { type: FilterTypes.text },
            cellRenderer: {
              type: CellRendererTypes.html,
              renderHtml: this.areaFormatter
            }
        }       
    ];    
}

